import dayjs from "dayjs";

/**
 * Parses the input to dayJs, returns now for null
 */
export function parseDateToDayJs(input?: string | Date | number): dayjs.Dayjs {
  if (!input) {
    return dayjs();
  }

  if (input instanceof Date) {
    return dayjs(input);
  }

  if (typeof input === "number" || typeof input === "bigint") {
    return parseDateFromNumber(input);
  }

  if (typeof input === "string" && input.match(/^\d*$/)) {
    return parseDateFromNumber(parseInt(input));
  }

  // ok must be some kind of date string
  return dayjs(input);
}

function parseDateFromNumber(input: number) {
  // nanoseconds
  // eslint-disable-next-line no-loss-of-precision
  if (input > 999999999999999999) {
    return dayjs.unix(input / 1000000000);
  }
  // milliseconds
  if (input > 999999999999999) {
    return dayjs.unix(input / 1000000);
  }
  // milliseconds
  if (input > 999999999999) {
    return dayjs.unix(input / 1000);
  }
  // seconds
  return dayjs.unix(input);
}
